import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { ImageUploadCardComponent } from './image-upload-card.component';

@NgModule({
  declarations: [ImageUploadCardComponent],
  imports: [CommonModule, TranslateModule],
  exports: [ImageUploadCardComponent],
})
export class ImageUploadCardModule {}
